var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb d-flex"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": _vm.adjustPath(item)
      }
    }, [_c('span', {
      on: {
        "click": _vm.hideMobile
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "float-right align-self-end ml-auto",
    attrs: {
      "id": "userID"
    }
  }, [_vm._v("User ID: " + _vm._s(_vm.username))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b21f2c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = lgmY
// module chunks = 1